import api from "./api";

export async function getAdmins(params) {
  const res = await api.get("/admin", { params });
  return res.data.data;
}

export async function createAdmin(payload) {
  const res = await api.post("/admin", payload);
  return res.data.data;
}

export async function updateAdmin(id, payload) {
  const res = await api.put(`/admin/${id}`, payload);
  return res.data.data;
}

export async function deleteAdmin(id) {
  const res = await api.delete(`/admin/${id}`);
  return res.data.data;
}
 